export default __webpack_public_path__ + "static/media/phantom-wallet.b28cc63f.png";